import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import { UserModule } from "@/store/modules/user";
import { NotificationModule } from "@/store/modules/notification";
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes: routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (localStorage.authToken) {
      UserModule.LoadProfileUser()
        .then((res) => {
          const les: any = res;
          NotificationModule.LoadCountNotif();
          next();
          if (
            les.data.data.access_group_id == "6" &&
            to?.fullPath?.includes("home")
          ) {
            next({ path: "/utilities" });
          }
        })
        .catch(() => {
          UserModule.Logout().then(() => {
            next({ path: "/auth" });
          });
        });
    } else {
      UserModule.Logout().then(() => {
        next({ path: "/auth" });
      });
    }
  } else {
    if (UserModule.authToken && to.path === "/auth") {
      UserModule.LoadProfileUser().then((res) => {
        const les: any = res;
        if (
          les.data.data.access_group_id == "6"
        ) {
          next({ path: "/utilities" });
        }
        next({ path: "/home" });
      });
    } else {
      next();
    }
  }
});

router.onError((error) => {
  if (error.name === 'NavigationDuplicated') {
    console.log('Navigation Duplicated:', error.message)
  }
})


const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location: any) {
  return (originalPush.call(this, location) as any).catch(err => {
    if (err.name !== "NavigationDuplicated") throw err;
  });
};

const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location: any) {
  return (originalReplace.call(this, location) as any).catch(err => {
    if (err.name !== "NavigationDuplicated") throw err;
  });
};

export default router;
